import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Components/Global/Header'; // Adjust the path as necessary
import Home from './pages/Home';
import Registration from './pages/Registration';
import Judge from './pages/Judge/Landing'; // Adjust the path as necessary
import Checkout from './pages/Checkout'; // Adjust the path as necessary
import Checkin from './pages/Checkin'; // Adjust the path as necessary
import currentDomain from './Utils/Utils';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import Winners from './pages/Winners';


const App = () => {

  const [preReg, setPreReg] = React.useState(true);

  useEffect(() => {
    fetch(`${currentDomain(location)}/api/config/prereg`)
      .then(res => res.json())
      .then(data => {
        setPreReg(data.preReg);
      })
      .catch(() => {
        // Leave the default (open) if the flag can't be fetched.
      });
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/registration" element={<Registration preReg={preReg} />} />
        <Route path="/judge" element={<Judge />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/winners" element={<Winners />} />
        <Route path="/checkin" element={<Checkin />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={true} newestOnTop={false} closeOnClick={true} rtl={false} limit={4} pauseOnFocusLoss={false} draggable pauseOnHover />
    </Router>

  );
};

export default App;

